/**
 * LA MATRIZ DE FUNCIONALIDADES POR TIPO, LEIDA (FUNCIONES-POR-TIPO-T1, Ares #42309).
 *
 * El panel no decide que trae cada tipo: lo lee de nexo_catalogs.funcionalidades_por_tipo por la API (PR 768) y lo agrupa
 * para pintarlo. Tolera camelCase y snake_case. Un defecto sin confirmar es una PROPUESTA (la decide Josse) y se dice.
 * Sin DOM: lo prueba scripts/check-funcionalidades-por-tipo.mjs.
 *
 * @module application/negocios/funcionalidadesPorTipo
 */

const de = (o, ...ks) => { for (const k of ks) if (o && o[k] !== undefined && o[k] !== null) return o[k]; return undefined; };

/**
 * @returns {{ tipos: {tipo:string, visible:string}[], grupos: Record<string, {grupo:string, filas:{funcionalidad:string, nombre:string, activa:boolean, confirmada:boolean}[]}[]> }}
 *   grupos[tipo] = la lista de ese tipo, por grupo, en el orden en que llego.
 */
export function leerMatriz(data) {
  const filas = Array.isArray(data) ? data : Array.isArray(de(data, 'items', 'Items')) ? de(data, 'items', 'Items') : [];
  const tipos = [];
  const grupos = {};
  for (const f of filas) {
    const tipo = String(de(f, 'tipo', 'Tipo') ?? '').trim();
    if (!tipo) continue;
    if (!grupos[tipo]) {
      grupos[tipo] = [];
      tipos.push({ tipo, visible: String(de(f, 'tipoVisible', 'tipo_visible', 'TipoVisible') ?? tipo) });
    }
    const grupo = String(de(f, 'grupo', 'Grupo') ?? 'otras');
    let g = grupos[tipo].find((x) => x.grupo === grupo);
    if (!g) { g = { grupo, filas: [] }; grupos[tipo].push(g); }
    g.filas.push({
      funcionalidad: String(de(f, 'funcionalidad', 'Funcionalidad') ?? ''),
      nombre: String(de(f, 'nombre', 'Nombre') ?? de(f, 'funcionalidad', 'Funcionalidad') ?? ''),
      activa: de(f, 'activa', 'Activa') === true,
      confirmada: de(f, 'confirmada', 'Confirmada') === true
    });
  }
  return { tipos, grupos };
}

/** Cuantas encendidas y cuantas propuestas sin confirmar tiene un tipo (la linea de resumen). */
export function resumenDelTipo(gruposDelTipo) {
  const todas = (gruposDelTipo || []).flatMap((g) => g.filas);
  return { total: todas.length, encendidas: todas.filter((f) => f.activa).length, propuestas: todas.filter((f) => !f.confirmada).length };
}

/** La causa en palabras, por motivo del cliente (regla F3: un mensaje por causa). */
export function fraseDeLaFalla(motivo) {
  if (motivo === 'NO_PUBLICADO') return 'El catalogo de funcionalidades todavia no esta publicado en la API.';
  if (motivo === 'PROHIBIDO') return 'Tu sesion no tiene permiso para ver el catalogo.';
  if (motivo === 'SIN_RED') return 'No pudimos hablar con la API ahora. Intenta de nuevo.';
  return 'La API respondio con un error.';
}
